import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  roles: [],
  role: {
    id: null,
  },
  resources: {},
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.ROLES_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('roles', payload);
    case types.ROLE_SUCCESS:
    case types.CREATE_ROLE_SUCCESS:
    case types.UPDATE_ROLE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('role', payload);
    case types.RESOURCES_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('resources', payload);
    case types.DELETE_ROLE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('roles', remove({ id: payload })(state.roles));
    case types.ROLES_REQUEST:
    case types.ROLE_REQUEST:
    case types.CREATE_ROLE_REQUEST:
    case types.UPDATE_ROLE_REQUEST:
    case types.RESOURCES_REQUEST:
    case types.DELETE_ROLE_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.ROLES_FAILURE:
    case types.ROLE_FAILURE:
    case types.RESOURCES_FAILURE:
    case types.CREATE_ROLE_FAILURE:
    case types.UPDATE_ROLE_FAILURE:
    case types.DELETE_ROLE_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_ROLE:
      return state.set('role', requestReducerState().role);
    default:
      return state;
  }
};
